import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'

export const useLockedUsersWidget = () =>
  useWidgetData<StatisticValueMetadata>('locked-users')
